﻿import {useRef} from "react";
import {useControlId} from "../helpers/useControlId";
import {LabeledControlAriaProps} from "./LabeledControl";

export type LabeledControlData = {
	componentId: string,
	ariaRef: React.RefObject<LabeledControlAriaProps | undefined>;
}

export function useLabeledControl(id?: string): LabeledControlData {
	const componentId = useControlId(id);
	const ariaRef = useRef<LabeledControlAriaProps | undefined>(undefined);
	return {componentId, ariaRef};
}
